import {toggleModal, getActiveModals} from 'wildlabs-frontend-core/js/modal';

window.addEventListener('modal:open', (event) => {
  if (event.target.id === 'register') {
    const modals = getActiveModals()
    if (modals['mobile-nav']) {
      toggleModal('mobile-nav');
    }
  }
});
